import React from 'react';
import { programsData } from '../../data/programsData';
import RightArrow from '../../assets/rightArrow.png';

import './Programs.css';

const Programs = () => {
  return (
    <div className="Programs" id="programs">
        <div className="programs-header">
            <span className="stroke-text">გაიცანი ჩვენი</span>
            <span>პროგრამები</span>
            <span className="stroke-text">შენი ფორმისთვის</span>
        </div>
        <div className="program-categories">
            {programsData.map((program) => (
                <div className="category" key={program.heading}>
                    {program.image}
                    <span>{program.heading}</span>
                    <span>{program.details}</span>
                    <div className="join-now">
                        <span>შემოგვიერთდი</span>
                        <img src={RightArrow} alt="ისარი"/>
                    </div>
                </div>
            ))}
        </div>
    </div>
  );
}

export default Programs;
